import { useSelector } from 'react-redux';
export function isTransportOverlayDisabled() {
    return useSelector((state) => { var _a; return !!((_a = state.PlaybackStates.visualPlayQueue) === null || _a === void 0 ? void 0 : _a.isDisabled); });
}
